import { useState, useEffect, useRef, forwardRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useRouter } from "next/router";
import * as Yup from "yup";

import UploadIcon from "@/elements/Shared/SVGs/UploadIcon";

import styles from "../forms.module.scss";

import submitForm from "@/utils/Forms/submitForm";

import handleClassName from "@/utils/handleClassName";

import FormType from "@/interfaces/Forms/FormType";

type FormProps = {
  formJobsOptions: { title: string; slug: string }[];
  formFieldsMap: FormType;
  formID: number;
};

function ContactCarriere({
  formJobsOptions,
  formFieldsMap,
  formID,
}: FormProps) {
  const [isFormSuccessfullySend, setIsformSuccesfullySend] = useState(false);
  const [isFormGotError, setIsformGotError] = useState(false);
  const [formMessage, setFormMessage] = useState("");
  const [validationsOption, setValidationOptions] = useState([]);
  const uploadFileRef = useRef(null);
  const router = useRouter();

  const validationRequired = "Ce champ est requis";
  const phoneRegex = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;

  const initialValues: FormType = {
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    jobTitle:
      router.pathname !== "/carrieres/[career_name]"
        ? ""
        : formJobsOptions[0].slug,
    fileUpload: {},
    description: "",
    name: "",
  };

  useEffect(() => {
    let validation = [];

    formJobsOptions.map((job) => {
      return validation.push(job.slug);
    });

    setValidationOptions(validation);
  }, []);

  return (
    <div className={handleClassName(["forms"], styles)}>
      <Formik
        initialValues={initialValues}
        validationSchema={Yup.object({
          firstname: Yup.string()
            .max(20, "Doit comporter 20 caractères ou moins")
            .required(validationRequired),
          lastname: Yup.string()
            .max(20, "Doit comporter 20 caractères ou moins")
            .required(validationRequired),
          email: Yup.string()
            .email("Adresse courriel non valide")
            .required(validationRequired),
          phone: Yup.string()
            .matches(
              phoneRegex,
              "Veuillez vérifier le formatage du numéro de téléphone. (EX: 123 444-5555)"
            )
            .required(validationRequired),
          jobTitle: Yup.string()
            .oneOf(validationsOption, "Type d'emploi non valide")
            .required(validationRequired),
          // fileUpload: Yup.object()
          //   .shape({
          //     lastModified: Yup.number(),
          //     lastModifiedDate: Yup.string(),
          //     name: Yup.string(),
          //     size: Yup.number(),
          //     type: Yup.string(),
          //     webkitRelativePath: Yup.string(),
          //   })
          //   .required("requis"),
          description: Yup.string().required(validationRequired),
          name: Yup.string().oneOf([""]),
        })}
        onSubmit={async (values) => {
          if (!isFormSuccessfullySend) {
            let formData = new FormData();

            Object.entries(values).forEach((e) => {
              if (e[1].length !== 0 && e[1].length !== undefined) {
                if (e[0] === "fileUpload") {
                  formData.append(formFieldsMap[e[0]], e[1], e[1].name);
                } else {
                  formData.append(formFieldsMap[e[0]], e[1]);
                }
              }
            });

            formData.append("formID", formID.toString());

            const response = await submitForm(formData);

            if (response.code === 200) {
              setIsformSuccesfullySend(true);
              setIsformGotError(false);
              setFormMessage(
                "Merci de nous avoir contactés ! Nous vous répondrons dans les plus brefs délais."
              );
            } else {
              setIsformGotError(true);
              setFormMessage(response.message);
            }
          }
        }}
      >
        {({ values, setFieldValue, isSubmitting }) => (
          <Form>
            <div className={styles["forms--cell"]}>
              <ErrorMessage
                className={styles["forms--errors"]}
                name="firstname"
                component="div"
              />
              <Field
                type="firstname"
                name="firstname"
                placeholder="Votre nom"
                onChange={(e) => {
                  if (isFormSuccessfullySend) setIsformSuccesfullySend(false);
                  setFieldValue("firstname", e.target.value);
                }}
              />

              <label htmlFor="firstname">Votre nom</label>
            </div>

            <div className={styles["forms--cell"]}>
              <ErrorMessage
                className={styles["forms--errors"]}
                name="lastname"
                component="div"
              />
              <Field
                type="lastname"
                name="lastname"
                placeholder="Votre prénom"
                onChange={(e) => {
                  if (isFormSuccessfullySend) setIsformSuccesfullySend(false);
                  setFieldValue("lastname", e.target.value);
                }}
              />
              <label htmlFor="lastname">Votre prénom</label>
            </div>

            <div className={styles["forms--cell"]}>
              <ErrorMessage
                className={styles["forms--errors"]}
                name="email"
                component="div"
              />
              <Field
                type="email"
                name="email"
                placeholder="johndoe@example.com"
                onChange={(e) => {
                  if (isFormSuccessfullySend) setIsformSuccesfullySend(false);
                  setFieldValue("email", e.target.value);
                }}
              />
              <label htmlFor="email">Votre courriel</label>
            </div>

            <div className={styles["forms--cell"]}>
              <ErrorMessage
                className={styles["forms--errors"]}
                name="phone"
                component="div"
              />
              <Field
                type="phone"
                name="phone"
                placeholder="450 555-5555"
                onChange={(e) => {
                  if (isFormSuccessfullySend) setIsformSuccesfullySend(false);
                  setFieldValue("phone", e.target.value);
                }}
              />
              <label htmlFor="phone">Téléphone</label>
            </div>

            <div className={styles["forms--cell"]}>
              <ErrorMessage
                className={styles["forms--errors"]}
                name="jobTitle"
                component="div"
              />

              <div className={styles["forms--select"]}>
                <Field
                  type="jobTitle"
                  as="select"
                  name="jobTitle"
                  onChange={(e) => {
                    if (isFormSuccessfullySend) setIsformSuccesfullySend(false);
                    setFieldValue("jobTitle", e.target.value);
                  }}
                >
                  {router.pathname !== "/carrieres/[career_name]" && (
                    <option value="Selectionnez un poste">
                      Selectionnez un poste
                    </option>
                  )}
                  {formJobsOptions.map((job, i) => {
                    return (
                      <option key={`jobOption-${i}`} value={job.slug}>
                        {job.title}
                      </option>
                    );
                  })}
                </Field>
              </div>
              <label htmlFor="jobTitle">Nom du poste</label>
            </div>

            <div className={styles["forms--cell"]}>
              <div className={styles["upload-file"]} ref={uploadFileRef}>
                <Field
                  type="file"
                  name="file"
                  placeholder=""
                  onChange={(event) => {
                    if (isFormSuccessfullySend) setIsformSuccesfullySend(false);
                    setFieldValue("fileUpload", event.target.files[0]);
                  }}
                />
              </div>

              <ErrorMessage
                className={styles["forms--errors"]}
                name="file"
                component="div"
              />

              <button
                type="button"
                className={styles["upload"]}
                onClick={() => {
                  uploadFileRef.current.children["file"].click();
                }}
              >
                <UploadIcon />

                <span>
                  {values.fileUpload && values.fileUpload.name
                    ? values.fileUpload.name
                    : "Téléverser un fichier"}
                </span>
              </button>

              <label htmlFor="file">Votre CV</label>
            </div>

            <div
              className={handleClassName(["forms--cell", "full-width"], styles)}
            >
              <ErrorMessage
                className={styles["forms--errors"]}
                name="description"
                component="div"
              />
              <Field
                type="description"
                as="textarea"
                name="description"
                placeholder="Parlez-nous de vous!"
                rows="3"
                onChange={(e) => {
                  if (isFormSuccessfullySend) setIsformSuccesfullySend(false);
                  setFieldValue("description", e.target.value);
                }}
              />
              <label htmlFor="description">Message</label>
            </div>

            <div className={"sr-only"}>
              <Field
                type="name"
                name="name"
                placeholder="ton nom ici"
                autocomplete="off"
                onChange={(e) => {
                  if (isFormSuccessfullySend) setIsformSuccesfullySend(false);
                  setFieldValue("name", e.target.value);
                }}
              />
              <label htmlFor="name"></label>
            </div>

            <button
              className={handleClassName(
                [
                  "forms--submit",
                  isFormSuccessfullySend
                    ? "forms--success"
                    : "forms--not-submited",
                ],
                styles
              )}
              type="submit"
              disabled={isSubmitting}
            >
              <div className={styles["inner-btn"]}>
                {isFormSuccessfullySend
                  ? "Envoyé avec succès"
                  : "Envoyez votre candidature"}
              </div>
            </button>

            <div
              className={handleClassName(
                [
                  "forms--submit-message",
                  isFormGotError ? "forms--errors" : "",
                  isFormGotError || isFormSuccessfullySend ? "visible" : "",
                ],
                styles
              )}
            >
              <p>{formMessage}</p>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default ContactCarriere;
